import { useIsomorphicLayoutEffect as useLayoutEffect } from '@hooks/use-isomorphic-layout-effect';
import cn from 'classnames';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import styles from './route-change-indicator.module.scss';

const RouteChangeIndicator = React.memo(() => {
  const [isChanging, setChanging] = useState(false);

  const { events } = useRouter();

  useLayoutEffect(() => {
    const startChange = (
      _route: string,
      options: { shallow?: boolean } = {},
    ) => {
      if (!options.shallow) {
        setChanging(true);
      }
    };

    const endChange = (_route: string, options: { shallow?: boolean } = {}) => {
      if (!options.shallow) {
        setChanging(false);
      }
    };

    events.on('routeChangeStart', startChange);
    events.on('routeChangeComplete', endChange);
    events.on('routeChangeError', endChange);

    return () => {
      events.off('routeChangeStart', startChange);
      events.on('routeChangeComplete', endChange);
      events.on('routeChangeError', endChange);
    };
  }, [events]);

  if (isChanging) {
    return <div className={cn(styles.container)}></div>;
  } else {
    return null;
  }
});

RouteChangeIndicator.displayName = 'RouteChangeIndicator';

export default RouteChangeIndicator;
